export const WORK_STATUS = [
    { label: 'Tất cả trạng thái', value: '' },
    { label: 'Chưa bắt đầu', value: 'NOT_STARTED' },
    { label: 'Đang thực hiện ', value: 'IN_PROGRESS' },
    { label: 'Hoàn thành', value: 'COMPLETED' },
  ];

  export const PRIORITY = [
     { label: 'Chưa xác định', value: 'UNKNOWN' },
    { label: 'Thấp', value: 'LOW' },
    { label: 'Trung bình', value: 'MEDIUM' },
    { label: 'Cao', value: 'HIGH' },
  ]